// token current role / roles
export enum ROLES_MODULE {
  SUPERVISOR = 'Supervisor',

  RIGHT_DO_RPG_S = 'rightDoRPgS',
  RIGHT_DO_RPG_S_SEC = 'rightDoRPgSSec',
  RIGHT_DO_RPG_S_GO = 'rightDoRPgSGO',

  RIGHT_INTERVIEW_PANEL = 'rightInterviewPanel',

  RIGHT_DRC_CHAIR = 'rightDRCChair',
  RIGHT_DRC_SEC = 'rightDRCSec',
  RIGHT_DRC = 'rightDRC',
  RIGHT_DRC_GO = 'rightDRCGO',

  RIGHT_FRC = 'rightFRC',
  RIGHT_FRC_CHAIR = 'rightFRCChair',
  RIGHT_FRC_GO = 'rightFRCGO',
  RIGHT_FRC_SEC = 'rightFRCSec',

  RIGHT_GS = 'rightGS',
  RIGHT_GSB = 'rightGSB',
  RIGHT_GSB_CHAIR = 'rightGSBChair',
  RIGHT_GSB_GO = 'rightGSBGO',
  RIGHT_GSB_SEC = 'rightGSBSec',

  RIGHT_PANEL = 'rightPanel',
  RIGHT_AR = 'rightAR',
  RIGHT_HOD_DOS = 'rightHodDos',
  RIGHT_HOD_DOS_SEC = 'rightHodDosSec',
  RIGHT_VPRI = 'rightVPRI',
  NA = 'N/A', // in case the auth has not get the role
}

export enum GS_ROLES_MODULE {
  RIGHT_GS = 'rightGS',
  RIGHT_GSB = 'rightGSB',
  RIGHT_GSB_CHAIR = 'rightGSBChair',
  RIGHT_GSB_GO = 'rightGSBGO',
  RIGHT_GSB_SEC = 'rightGSBSec',
}

export enum UserRole {
  SUPERVISOR = 'SUPERVISOR',

  DO_RPG_S = 'DO_RPG_S',
  DO_RPG_S_SEC = 'DO_RPG_S_SEC',
  DO_RPG_S_GO = 'DO_RPG_S_GO',

  INTERVIEW_PANEL = 'INTERVIEW_PANEL',
  DRC = 'DRC',
  DRC_CHAIR = 'DRC_CHAIR',
  DRC_SEC = 'DRC_SEC',
  DRC_GO = 'DRC_GO',
  FRC = 'FRC',
  FRC_CHAIR = 'FRC_CHAIR',
  FRC_SEC = 'FRC_SEC',
  FRC_GO = 'FRC_GO',
  GSB = 'GSB',
  GSB_CHAIR = 'GSB_CHAIR',
  GSB_SEC = 'GSB_SEC',
  GSB_GO = 'GSB_GO',
  HOD_DOS = 'HOD_DOS',
  HOD_DOS_SEC = 'HOD_DOS_SEC',
  VPRI = 'VPRI',
  GS = 'GS',
  PANEL = 'PANEL',
  AR = 'AR',
  APPLICANT = 'APPLICANT',
}

export const roleModulesMap: Partial<
  Record<ROLES_MODULE, { navLink: string }>
> = {
  [ROLES_MODULE.SUPERVISOR]: { navLink: '/internal/nominations' },

  // Grouped roles for dorpgs homepage
  ...Object.fromEntries(
    [
      ROLES_MODULE.RIGHT_DO_RPG_S,
      ROLES_MODULE.RIGHT_DO_RPG_S_SEC,
      ROLES_MODULE.RIGHT_DO_RPG_S_GO,
    ].map(role => [role, { navLink: '/internal/dorpgs-homepage' }]),
  ),

  // Grouped roles for interview homepage
  [ROLES_MODULE.RIGHT_INTERVIEW_PANEL]: {
    navLink: '/internal/interview-homepage',
  },

  // Grouped roles for drc homepage
  ...Object.fromEntries(
    [
      ROLES_MODULE.RIGHT_DRC_CHAIR,
      ROLES_MODULE.RIGHT_DRC_SEC,
      ROLES_MODULE.RIGHT_DRC,
      ROLES_MODULE.RIGHT_DRC_GO,
    ].map(role => [role, { navLink: '/internal/drc-homepage' }]),
  ),

  // Grouped roles for gs homepage
  ...Object.fromEntries(
    [
      ROLES_MODULE.RIGHT_GS,
      ROLES_MODULE.RIGHT_GSB,
      ROLES_MODULE.RIGHT_GSB_CHAIR,
      ROLES_MODULE.RIGHT_GSB_GO,
      ROLES_MODULE.RIGHT_GSB_SEC,
    ].map(role => [role, { navLink: '/internal/gs-homepage' }]),
  ),

  // Grouped roles for frc homepage
  ...Object.fromEntries(
    [
      ROLES_MODULE.RIGHT_FRC,
      ROLES_MODULE.RIGHT_FRC_CHAIR,
      ROLES_MODULE.RIGHT_FRC_GO,
      ROLES_MODULE.RIGHT_FRC_SEC,
    ].map(role => [role, { navLink: '/internal/frc-homepage' }]),
  ),

  // Grouped roles for panel homepage
  [ROLES_MODULE.RIGHT_PANEL]: { navLink: '/internal/panel-homepage' },

  // Grouped roles for ar homepage
  [ROLES_MODULE.RIGHT_AR]: { navLink: '/internal/ar-homepage' },

  // Grouped roles for hod dos homepage
  ...Object.fromEntries(
    [ROLES_MODULE.RIGHT_HOD_DOS, ROLES_MODULE.RIGHT_HOD_DOS_SEC].map(role => [
      role,
      { navLink: '/internal/hod-dos-homepage' },
    ]),
  ),
};

export const handleRoleNavigation = (role: string): void => {
  // if the role is applicant, redirect to applications page
  if (role === 'applicant') {
    window.location.href = '/applications';
    return;
  }

  // if the role is not in the roleModulesMap, redirect to the home page
  const navLink = roleModulesMap[role as ROLES_MODULE]?.navLink;
  if (navLink != null) {
    window.location.href = navLink;
  }
};

export const handleMapping = (role: string): string => {
  const map: Record<ROLES_MODULE, string> = {
    [ROLES_MODULE.SUPERVISOR]: 'SUPERVISOR',

    [ROLES_MODULE.RIGHT_DO_RPG_S]: 'RIGHT_DO_RPG_S',
    [ROLES_MODULE.RIGHT_DO_RPG_S_SEC]: 'RIGHT_DO_RPG_S_SEC',
    [ROLES_MODULE.RIGHT_DO_RPG_S_GO]: 'RIGHT_DO_RPG_S_GO',

    [ROLES_MODULE.RIGHT_INTERVIEW_PANEL]: 'RIGHT_INTERVIEW_PANEL',

    [ROLES_MODULE.RIGHT_DRC_CHAIR]: 'RIGHT_DRC_CHAIR',
    [ROLES_MODULE.RIGHT_DRC_SEC]: 'RIGHT_DRC_SEC',
    [ROLES_MODULE.RIGHT_DRC]: 'RIGHT_DRC',
    [ROLES_MODULE.RIGHT_DRC_GO]: 'RIGHT_DRC_GO',

    [ROLES_MODULE.RIGHT_FRC]: 'RIGHT_FRC',
    [ROLES_MODULE.RIGHT_FRC_CHAIR]: 'RIGHT_FRC_CHAIR',
    [ROLES_MODULE.RIGHT_FRC_GO]: 'RIGHT_FRC_GO',
    [ROLES_MODULE.RIGHT_FRC_SEC]: 'RIGHT_FRC_SEC',

    [ROLES_MODULE.RIGHT_GS]: 'RIGHT_GS',
    [ROLES_MODULE.RIGHT_GSB]: 'RIGHT_GSB',
    [ROLES_MODULE.RIGHT_GSB_CHAIR]: 'RIGHT_GSB_CHAIR',
    [ROLES_MODULE.RIGHT_GSB_GO]: 'RIGHT_GSB_GO',
    [ROLES_MODULE.RIGHT_GSB_SEC]: 'RIGHT_GSB_SEC',

    [ROLES_MODULE.RIGHT_VPRI]: 'RIGHT_VPRI',

    [ROLES_MODULE.RIGHT_PANEL]: 'RIGHT_PANEL',

    [ROLES_MODULE.RIGHT_AR]: 'RIGHT_AR',

    [ROLES_MODULE.RIGHT_HOD_DOS]: 'RIGHT_HOD_DOS',
    [ROLES_MODULE.RIGHT_HOD_DOS_SEC]: 'RIGHT_HOD_DOS_SEC',

    [ROLES_MODULE.NA]: 'N/A',
  };
  return map[role as ROLES_MODULE];
};

export const UserRoleToModuleMap: Record<UserRole, ROLES_MODULE> = {
  [UserRole.SUPERVISOR]: ROLES_MODULE.SUPERVISOR,

  [UserRole.DO_RPG_S]: ROLES_MODULE.RIGHT_DO_RPG_S,
  [UserRole.DO_RPG_S_SEC]: ROLES_MODULE.RIGHT_DO_RPG_S_SEC,
  [UserRole.DO_RPG_S_GO]: ROLES_MODULE.RIGHT_DO_RPG_S_GO,

  [UserRole.INTERVIEW_PANEL]: ROLES_MODULE.RIGHT_INTERVIEW_PANEL,

  [UserRole.DRC_CHAIR]: ROLES_MODULE.RIGHT_DRC_CHAIR,
  [UserRole.DRC_SEC]: ROLES_MODULE.RIGHT_DRC_SEC,
  [UserRole.DRC]: ROLES_MODULE.RIGHT_DRC,
  [UserRole.DRC_GO]: ROLES_MODULE.RIGHT_DRC_GO,

  [UserRole.FRC]: ROLES_MODULE.RIGHT_FRC,
  [UserRole.FRC_CHAIR]: ROLES_MODULE.RIGHT_FRC_CHAIR,
  [UserRole.FRC_GO]: ROLES_MODULE.RIGHT_FRC_GO,
  [UserRole.FRC_SEC]: ROLES_MODULE.RIGHT_FRC_SEC,

  [UserRole.GS]: ROLES_MODULE.RIGHT_GS,
  [UserRole.GSB]: ROLES_MODULE.RIGHT_GSB,
  [UserRole.GSB_CHAIR]: ROLES_MODULE.RIGHT_GSB_CHAIR,
  [UserRole.GSB_GO]: ROLES_MODULE.RIGHT_GSB_GO,
  [UserRole.GSB_SEC]: ROLES_MODULE.RIGHT_GSB_SEC,

  [UserRole.VPRI]: ROLES_MODULE.RIGHT_VPRI,

  [UserRole.PANEL]: ROLES_MODULE.RIGHT_PANEL,

  [UserRole.AR]: ROLES_MODULE.RIGHT_AR,

  [UserRole.HOD_DOS]: ROLES_MODULE.RIGHT_HOD_DOS,
  [UserRole.HOD_DOS_SEC]: ROLES_MODULE.RIGHT_HOD_DOS_SEC,
  [UserRole.APPLICANT]: ROLES_MODULE.NA,
};

export function getUserRoleByRoleModule(
  roleModule: ROLES_MODULE | null,
): UserRole | undefined {
  if (roleModule === null) return undefined;
  for (const [userRole, mappedRoleModule] of Object.entries(
    UserRoleToModuleMap,
  )) {
    if (mappedRoleModule === roleModule) {
      return userRole as UserRole;
    }
  }
  return undefined;
}
